export enum ProductSubType {
  TV_MAIN = 'tv_main',
  TV_SMARTCARD = 'tv_smartcard',
  TV_RECEIVER = 'tv_receiver',
  TV_CHANNELPACKAGE = 'tv_channelpackage',
  INTERNET_MAIN = 'internet_main',
  PHONE_MAIN = 'phone_main',
  PHONE_BUNDLES = 'phone_bundles',
}
